<template>
    <div class="additional-wrapper" v-if='propsData.writer'>
        <span class="con-writer sub-text-99">责任编辑: {{propsData.writer}}</span>
    </div>
</template>

<script>

export default {
    name: 'addtional',
    data () {
        return{
            model:{
                writer: '你猜',
                key: '', // 用于向后端请求阅读量 
                app: '', 
                token: ''
            }
        }
    },
    props:{
        propsData:{
            default(){
                return {
                    writer: '',
                }
            },
            type: Object
        }
    },
    computed: {
    },
    beforeCreate: function () {
    },
    created: function () {
    },
    mounted: function () {
    },
    methods: {
    }
}
</script>

<style lang="less" scoped>
@import '../../common/style/common-color.less';

.additional-wrapper{
    margin-top: 20px;
    padding-left: 1px;
    >.con-writer{
        font-size: 14px;
        line-height: 19px;
    }
}
</style>
